/* eslint-disable react/destructuring-assignment */
import { GetServerSideProps, GetStaticProps, NextPage } from 'next';
import Head from 'next/head';

import Layout from '@/components/Layout';
import { makeApiClient, api } from '@/services/api';
import TemplateEventById, {
  TemplateEventByIdProps,
} from '@/templates/event-by-id';
import { makeCdnLink, stripHtml } from '@/utils';

const EventById: NextPage<TemplateEventByIdProps> = props => {
  return (
    <Layout
      seo={{
        image: makeCdnLink(props.rowEvent.imagemEvento) || null,
        title: props.rowEvent.nomeEvento,
        description: stripHtml(props.rowEvent.descEvento.slice(0, 160)),
      }}
    >
      <Head>
        <meta name="kdt:page" content="product" />
      </Head>
      <TemplateEventById {...props} />
    </Layout>
  );
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<
  TemplateEventByIdProps,
  {
    id: string;
    token: string;
    slug: string;
  }
> = async context => {
  try {
    // const api = makeApiClient();
    const path = `/v1/web/events/${context.params.id}`;
    const response = await api.get(path);

    return {
      props: {
        rowEvent: response.data.event,
        token: context.params.token,
      },
      revalidate: 120,
    };
  } catch {
    return {
      notFound: true,
      revalidate: 10,
    };
  }
};

export default EventById;
